const addProperties = (el, binding) => {
  Object.keys(binding.value).forEach((name) => {
    el.style.setProperty(`--${name}`, binding.value[name])
  })
}

export const CssVariables = {
  beforeMount(el: any, binding: any, vnode: any) {
    addProperties(el, binding)
  },
  updated(el: any, binding: any, vnode: any) {
    addProperties(el, binding)
  },
}
